import { ref } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia';
import { usePlayMixStore } from '~/stores/usePlayMixStore';

const playmix = (hubbleClient) => {
  const selected = ref([]);
  const selection = ref([]);
  const data = ref(null)
  const playMixStore = usePlayMixStore()
  const {
    selectedPlayServices
  } = storeToRefs(playMixStore)
  const getPlayMixServices = async (bundleId) => {
    if (data.value) { return }
    const res = await hubbleClient.playMix.getPlayMixServices(bundleId);
    data.value = res.data
    setInitialSelection(data.value.mixVasLimit)
    return res;
  }

  const setInitialSelection = (limit) => {
    selection.value = new Array(limit).fill(null);
  }
  const validatePlayMixServicesInCart = async (mixProductsInCart, bundleId) => {
    await getPlayMixServices(bundleId)
    let allValidServices = true
    mixProductsInCart.forEach(mixProduct => {
      if (data.value.productOfferingDTOWithContent.find(po => po.productOfferingDTO.id === mixProduct) === undefined) {
        allValidServices = false
      }
    })
    mixProductsInCart = [...new Set(mixProductsInCart)]
    return allValidServices && data.value.mixVasLimit === mixProductsInCart.length
  }
  return {
    validatePlayMixServicesInCart,
    selectedPlayServices,
    getPlayMixServices,
    data,
    selected,
    selection
  }
}

export default function (identifier, appContext) {
  const playMixStore = usePlayMixStore()
  if (playMixStore.mixes[identifier]) {
    return playMixStore.mixes[identifier]
  }
  playMixStore.mixes[identifier] = playmix(appContext)
  return playMixStore.mixes[identifier]
}
